import React from "react";
import { Facebook, Instagram, Twitter, Linkedin } from "lucide-react"; // Social icons

const CTASection = () => {
  return (
    <section className="bg-[#A3B8CF] py-16 px-6 text-center text-white">
      <div className="max-w-5xl mx-auto">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Your Weight Loss Journey Starts Today.
        </h2>
        <p className="text-lg md:text-xl mb-8">
          Stop waiting for the “right time.” Start moving now—Revibe makes it
          easy.
        </p>

        {/* CTA Button */}
        <a
          href="#download"
          className="inline-block hover:bg-[#b8ea03] bg-[#C5F122] text-gray-800  font-semibold px-8 py-3 rounded-full shadow-md hover:shadow-xl hover:scale-105 transition"
        >
          👉 Download the App Now
        </a>

        {/* Store Badges */}
        <div className="mt-10 flex justify-center gap-6 flex-wrap">
          <a
            href="https://apps.apple.com" // replace with real App Store link
            target="_blank"
            rel="noopener noreferrer"
          >
            {/* <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on App Store"
              className="h-12"
            /> */}
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.app.revibe" // replace with real Play Store link
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
              className="h-12"
            />
          </a>
        </div>

        {/* Social Icons */}
        <div className="mt-12 flex justify-center gap-6">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Facebook className="w-6 h-6 hover:text-gray-200 transition" />
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram className="w-6 h-6 hover:text-gray-200 transition" />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Twitter className="w-6 h-6 hover:text-gray-200 transition" />
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Linkedin className="w-6 h-6 hover:text-gray-200 transition" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
